import OverviewVM from './overview-vm';
export default {
  prepUI: function() {
    //TODO
  },
  init: function() {
    ko.applyBindingsWithValidation(new OverviewVM(), document.getElementById('gradebook_coursework'), Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};
